

import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
const SummaryTab = ({ summary, error, hideTabs }) => {
  const { ranking, antimatter } = hideTabs || {}
  if (error) {
    return <span> {error.message}</span>
  }

  if (!summary) {
    return (
      <h2>
        <FormattedMessage id="phase.waiting" />
      </h2>
    )
  }

  const range = 'map.buildings.city_level.' + (summary.cityLevel ? summary.cityLevel : 1)

  return (
    <div>
      <div className="mars--content data">
        <div className="mars--results">
          <div className="mars--results__item">
            <FormattedMessage id="indicators.coins" />
            <span className="mars--border"></span>
            <span>
              {summary.coins} <i className="icon-coin"> </i>
            </span>
          </div>

          {!ranking && (
            <div className="mars--results__item">
              <span>
                <FormattedMessage id="indicators.ranking" />
              </span>
              <span className="mars--border"></span>
              <span className="value">
                <span className="small">
                  <FormattedMessage id="indicators.colony" />
                </span>
                <span>{summary.position}</span>
                {summary.federationPosition ? (
                  <React.Fragment>
                    <span className="separator">|</span>
                    <span className="orange">{summary.federationPosition}</span>
                    <span className="small">
                      <FormattedMessage id="indicators.federation" />
                    </span>
                  </React.Fragment>
                ) : null}
              </span>
            </div>
          )}

          {!antimatter && (
            <div className="mars--results__item">
              <FormattedMessage id="indicators.antimatter" />
              <span className="mars--border"></span>
              <span>
                {summary.antimatter} <i className="icon-antimateria"> </i>
              </span>
            </div>
          )}
        </div>
        <div className="mars--block">
          <div className="mars--cologne">
            <ul className="mars--list heading">
              <li className="mars--list__item">
                <FormattedMessage id="indicators.happiness" />{' '}
              </li>
              <li className="mars--list__item">
                <span className="mars--border"></span>
              </li>
              <li className="mars--list__item justify--center">
                <span className="value important">{summary.happiness}</span>
              </li>
            </ul>
            <ul className="mars--list">
              <li className="mars--list__item arrow--down "></li>
              <li className="mars--list__item">
                <span className="uppercase">
                  <FormattedMessage id="indicators.ResidencyAplication" />
                </span>
              </li>
              <li className="mars--list__item arrow--down"></li>
              <li className="mars--list__item justify--center">
                <span className="icon-angle-down orange"></span>
              </li>
              <li className="mars--list__item justify--center">
                <span className="value orangeBottom important">{summary.happiness}</span>
              </li>
            </ul>
          </div>
          <div className="mars--resources">
            <ul className="mars--list">
              <li className="mars--list__item">
                <span className="mars--last__colognes">
                  <FormattedMessage
                    id="indicators.lastSettlers"
                    values={{ lastSettlers: summary.settlersOld }}
                  />
                </span>
              </li>
              <li className="mars--list__item">
                <span className="value orange">{summary.settlers - summary.settlersOld}</span>
                <span className="uppercase">
                  <FormattedMessage id="indicators.newSettlers" />
                </span>
              </li>
            </ul>
            <ul className="mars--list heading">
              <li className="mars--list__item"></li>
              <li className="mars--list__item">
                <span
                  className={summary.oxygen - summary.oxygenOld > 0 ? 'success' : 'failed'}
                  title="indicators.variation"
                >
                  {summary.oxygen - summary.oxygenOld}
                </span>
                <span className="value">{summary.oxygen}</span>
                <span>
                  <FormattedMessage id="indicators.oxygen" />
                </span>
              </li>
              <li className="mars--list__item">
                <span
                  className={summary.water - summary.waterOld > 0 ? 'success' : 'failed'}
                  title="indicators.variation"
                >
                  {summary.water - summary.waterOld}
                </span>
                <span className="value">{summary.water}</span>
                <span>
                  <FormattedMessage id="indicators.water" />
                </span>
              </li>
              <li className="mars--list__item">
                <span
                  className={summary.food - summary.foodOld > 0 ? 'success' : 'failed'}
                  title="indicators.variation"
                >
                  {summary.food - summary.foodOld}
                </span>
                <span className="value">{summary.food}</span>
                <span>
                  <FormattedMessage id="indicators.food" />
                </span>
              </li>
              <li className="mars--list__item">
                <span
                  className={summary.energy - summary.energyOld > 0 ? 'success' : 'failed'}
                  title="indicators.variation"
                >
                  {summary.energy - summary.energyOld}
                </span>
                <span className="value">{summary.energy}</span>
                <span>
                  <FormattedMessage id="indicators.energy" />
                </span>
              </li>
              <li className="mars--list__item">
                <span
                  className={summary.home - summary.homeOld > 0 ? 'success' : 'failed'}
                  title="indicators.variation"
                >
                  {summary.home - summary.homeOld}
                </span>
                <span className="value">{summary.home}</span>
                <span>
                  <FormattedMessage id="indicators.home" />
                </span>
              </li>
            </ul>
          </div>
          <div className="mars--cologne robot">
            <ul className="mars--list heading">
              <li className="mars--list__item">
                <FormattedMessage id="indicators.currentSettlers" />
              </li>
              <li className="mars--list__item">
                <span className="mars--border"></span>
              </li>
              <li className="mars--list__item mars--cologne__num">
                <span className="value important">{summary.settlers}</span>
                <span
                  className={`${summary.settlers > summary.settlersOld ? 'success' : 'failed'}`}
                >
                  <span>{Math.abs(summary.settlers - summary.settlersOld)}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

SummaryTab.propTypes = {
  summary: PropTypes.object,
  error: PropTypes.object,
  hideTabs: PropTypes.object,
}

export default injectIntl(SummaryTab)
